import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Spacer, Typography, useTheme } from '@qbe/ads-core';
import { useAppContent, useAppDispatch } from 'hooks';
import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import Loading from '~/components-ds/Loading';
import Modal from '~/components-ds/Modal';
import { useAppNavigate } from '~/hooks/useAppNavigate';
import { qalTrackEngagementAction } from '~/thunks/analytics';
import { retrieveQuoteAction } from '~/thunks/retrieve-quote/retrieveQuoteAction';

export const RqQuote = 'rq_quote';
export const RqEmail = 'rq_email';
export const RqToken = 'rq_token';

const RetrieveQuote: React.FC = () => {
  const theme = useTheme();

  const { getTextContent } = useAppContent({
    basePath: 'dsme.retrieveQuote.fields.retrieveQuoteModal',
  });

  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();

  const hasFetchedRef = useRef(false);

  const [searchParams] = useSearchParams();

  const rqQuote = searchParams.get(RqQuote);
  const rqEmail = searchParams.get(RqEmail);
  const rqToken = searchParams.get(RqToken);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    dispatch(
      retrieveQuoteAction({
        quoteNumber: rqQuote!,
        email: rqEmail!,
        accessToken: rqToken!,
        navigate,
      })
    );
  }, [dispatch, navigate, rqEmail, rqQuote, rqToken]);

  useEffect(() => {
    dispatch(
      qalTrackEngagementAction({
        eventAction: 'modal: open',
        eventLabel: 'Retrieve Quote Modal',
        data: {},
      })
    );
  }, [dispatch]);

  return (
    <Modal
      id="retrieve-quote-modal"
      analyticsModalName="retrieve quote modal"
      open
      title={getTextContent('title')}
      iconProps={{
        muiIcon: InfoOutlined,
        // TODO - https://qbe-appservices.atlassian.net/browse/AD1-445
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        color: theme.color.icon.info,
      }}
      primaryBtnProps={{
        label: '',
        sx: {
          display: 'none',
        },
      }}
    >
      <>
        <Typography>{getTextContent('description')}</Typography>
        <Spacer size="md" />
        <Loading />
      </>
    </Modal>
  );
};

export default RetrieveQuote;
